import { render } from "./UserInfo.vue?vue&type=template&id=5013c230"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/User/Home/UserInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5013c230"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5013c230', __exports__)) {
    api.reload('5013c230', __exports__)
  }
  
  module.hot.accept("./UserInfo.vue?vue&type=template&id=5013c230", () => {
    api.rerender('5013c230', render)
  })

}


export default __exports__